import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { PublicEmergencyOrders } from "./PublicEmergencyOrders";

export const publicEmergencyOrders = typeCheckAppModule({
    NAME,
    Container: PublicEmergencyOrders,
});
